import { type Areas, type Roles, roleByArea } from "./checkers/all";

export function getRolePermissionByArea(area: Areas, role: Roles) {
	return roleByArea[area][role];
}
